import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";



const blogData = [
  {
      title: "Are Refurbished Laptops Worth It in 2026?",
      desc: "जानिए refurbished laptops लेना सही है या नहीं, pros & cons के साथ।",
      img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8",
      date: "April 2026",
    },
    {
        title: "Top 5 Refurbished Laptops Under ₹30,000",
        desc: "Budget me best performance laptops — students & office users ke liye perfect.",
        img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853",
        date: "March 2026",
  },
  {
      title: "Refurbished vs New Laptop – Which One Should You Buy?",
      desc: "Comparison guide: price, performance aur value for money.",
      img: "https://images.unsplash.com/photo-1527430253228-e93688616381",
      date: "March 2026",
  },
  {
      title: "How We Test Refurbished Laptops Before Selling",
    desc: "Quality check process jisse aapko milta hai reliable laptop.",
    img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
    date: "February 2026",
},
{
    title: "Best Refurbished Laptops for Students in India",
    desc: "Online classes aur coding ke liye best affordable options.",
    img: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4",
    date: "February 2026",
},
{
    title: "Battery Life in Refurbished Laptops – What to Expect?",
    desc: "Battery health, performance aur real-life usage guide.",
    img: "https://images.unsplash.com/photo-1492724441997-5dc865305da7",
    date: "January 2026",
},
];

const Blogs = () => {
    const navigate = useNavigate();
  return (
    <div className="px-4 mt-8">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg md:text-2xl font-bold text-gray-800">
          Latest Blogs
        </h2>

        <button className="text-blue-600 text-xs md:text-sm">
          View All →
        </button>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">

        {blogData.map((blog, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -5 }}
            className="bg-white rounded-xl shadow-sm hover:shadow-lg overflow-hidden cursor-pointer"
          >

            {/* IMAGE */}
            <div className="relative h-28 md:h-40 overflow-hidden">
              <img
                src={blog.img}
                alt={blog.title}
                className="w-full h-full object-cover transition duration-500 hover:scale-105"
              />

              {/* DATE */}
              <span className="absolute top-1 left-1 bg-black/60 text-white text-[10px] px-2 py-0.5 rounded">
                {blog.date}
              </span>
            </div>

            {/* CONTENT */}
            <div className="p-2">

              <h3 className="text-[12px] md:text-sm font-semibold text-gray-800 line-clamp-2">
                {blog.title}
              </h3>

              <p className="text-[10px] md:text-xs text-gray-500 mt-1 line-clamp-2">
                {blog.desc}
              </p>

              <button  onclick={() => navigate(`/blog/${i + 1}`)} className="text-blue-600 text-[10px] md:text-xs mt-2">
                Read More →
              </button>

            </div>

          </motion.div>
        ))}

      </div>
    </div>
  );
};

export default Blogs;